document.addEventListener('DOMContentLoaded', () => {

    const slider = document.querySelector('.services__reels');
    const track  = document.querySelector('.services__track');

    if (!slider || !track) return;

    /*
    |--------------------------------------------------------------------------
    | CONFIG
    |--------------------------------------------------------------------------
    */

    const SPEED = 0.6;

    let position = 0;

    let autoplay = true;

    let resumeTimer = null;

    /*
    |--------------------------------------------------------------------------
    | CALCULAR ANCHO REAL DEL LOOP
    |--------------------------------------------------------------------------
    */

    const cards = track.querySelectorAll('.services__card');

    const totalCards = cards.length;

    const originalCards = totalCards / 3;

    let loopWidth = 0;

    for (let i = 0; i < originalCards; i++) {

        const card = cards[i];

        const styles =
            getComputedStyle(card);

        loopWidth += card.offsetWidth;

        loopWidth +=
            parseFloat(styles.marginLeft || 0);

        loopWidth +=
            parseFloat(styles.marginRight || 0);
    }

    const gap = parseFloat(
        getComputedStyle(track).gap || 0
    );

    loopWidth += gap * originalCards;

    /*
    |--------------------------------------------------------------------------
    | AUTOPLAY
    |--------------------------------------------------------------------------
    */

    function animate() {

        if (autoplay) {

            position -= SPEED;

            if (
                Math.abs(position)
                >= loopWidth
            ) {

                position += loopWidth;
            }

            track.style.transform =
                `translate3d(${position}px,0,0)`;
        }

        requestAnimationFrame(
            animate
        );
    }

    animate();

    /*
    |--------------------------------------------------------------------------
    | PAUSA
    |--------------------------------------------------------------------------
    */

    function pauseSlider() {

        autoplay = false;

        clearTimeout(
            resumeTimer
        );

        resumeTimer =
            setTimeout(() => {

                autoplay = true;

            }, 3000);
    }

    /*
    |--------------------------------------------------------------------------
    | DRAG
    |--------------------------------------------------------------------------
    */

    let isDragging = false;

    let startX = 0;

    let startY = 0;

    let dragStartPosition = 0;

    let isHorizontalDrag = false;

    function startDrag(event) {

        isDragging = true;

        isHorizontalDrag = false;

        slider.classList.add(
            'is-dragging'
        );

        pauseSlider();

        startX =
            getPositionX(event);

        startY =
            getPositionY(event);

        dragStartPosition =
            position;
    }

    function drag(event) {

        if (!isDragging) return;

        const currentX =
            getPositionX(event);

        const currentY =
            getPositionY(event);

        const diffX =
            currentX - startX;

        const diffY =
            currentY - startY;

        /*
        |--------------------------------------------------------------------------
        | SI EL MOVIMIENTO ES VERTICAL
        | DEJAMOS QUE LA PÁGINA HAGA SCROLL
        |--------------------------------------------------------------------------
        */

        if (!isHorizontalDrag) {

            if (
                Math.abs(diffY)
                > Math.abs(diffX)
            ) {

                return;
            }

            isHorizontalDrag = true;
        }

        if (
            event.cancelable
        ) {

            event.preventDefault();
        }

        position =
            dragStartPosition + diffX;

        while (
            Math.abs(position)
            >= loopWidth
        ) {

            position += loopWidth;
        }

        while (
            position > 0
        ) {

            position -= loopWidth;
        }

        track.style.transform =
            `translate3d(${position}px,0,0)`;
    }

    function endDrag() {

        if (!isDragging) return;

        isDragging = false;

        isHorizontalDrag = false;

        slider.classList.remove(
            'is-dragging'
        );

        pauseSlider();
    }

    /*
    |--------------------------------------------------------------------------
    | CLICK
    |--------------------------------------------------------------------------
    */

    slider.addEventListener(
        'click',
        pauseSlider
    );

    /*
    |--------------------------------------------------------------------------
    | DESKTOP
    |--------------------------------------------------------------------------
    */

    slider.addEventListener(
        'mousedown',
        startDrag
    );

    window.addEventListener(
        'mousemove',
        drag
    );

    window.addEventListener(
        'mouseup',
        endDrag
    );

    /*
    |--------------------------------------------------------------------------
    | TOUCH
    |--------------------------------------------------------------------------
    */

    if (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0
    ) {

        slider.addEventListener(
            'touchstart',
            startDrag,
            { passive: true }
        );

        slider.addEventListener(
            'touchmove',
            drag,
            { passive: false }
        );

        slider.addEventListener(
            'touchend',
            endDrag
        );

        slider.addEventListener(
            'touchcancel',
            endDrag
        );
    }

    /*
    |--------------------------------------------------------------------------
    | UTILIDADES
    |--------------------------------------------------------------------------
    */

    function getPositionX(event) {

        if (
            event.touches &&
            event.touches.length
        ) {

            return event.touches[0].clientX;
        }

        return event.clientX;
    }

    function getPositionY(event) {

        if (
            event.touches &&
            event.touches.length
        ) {

            return event.touches[0].clientY;
        }

        return event.clientY;
    }

});